export default [
  {
    path: '/project/:alias/:projectAlias/merge-request',
    name: 'merge-request-list',
    component: () => import('./pages/page-merge-request-list.vue')
  },
  {
    path: '/project/:alias/:projectAlias/merge-request/:id/edit',
    component: () => import('./pages/page-merge-request-edit.vue'),
    name: 'merge-request-edit',
    props: { isCreate: false }
  },
  {
    path: '/project/:alias/:projectAlias/merge-request/create',
    component: () => import('./pages/page-merge-request-edit.vue'),
    name: 'merge-request-create',
    props: { isCreate: true }
  },
  {
    path: '/project/:alias/:projectAlias/merge-request/:id',
    component: () => import('./pages/page-merge-request-item.vue'),
    children: [
      {
        path: '',
        component: () => import('./pages/page-merge-request-item-overview.vue'),
        name: 'merge-request-item'
      },
      {
        path: 'commit',
        component: () => import('./pages/page-merge-request-item-commit.vue'),
        name: 'merge-request-item-commit'
      },
      {
        path: 'diff',
        component: () => import('./pages/page-merge-request-item-diff.vue'),
        name: 'merge-request-item-diff',
        meta: { noScrollTop: true }
      },
      {
        path: 'pipeline',
        component: () => import('./pages/page-merge-request-pipeline.vue'),
        name: 'merge-request-pipeline'
      },
      {
        path: 'vulnerability',
        component: () => import('./pages/page-merge-request-security.vue'),
        name: 'merge-request-security'
      }
    ]
  },
  {
    path: '/project/:alias/:projectAlias/merge-request/:id/conflicts',
    component: () => import('./pages/conflicts/page-merge-request-conflicts-layout.vue'),
    children: [
      {
        path: '',
        component: () => import('./pages/conflicts/page-merge-request-conflicts.vue'),
        name: 'merge-request-conflicts'
      }
    ]
  }
];
